module.exports = __webpack_public_path__ + "img/logoNew.0b4215b7.png";